<template>
  <div>
    <div class="mb-2">
      <label class="form-label"><slider-switch
        :initially-checked="needsTaxcreditValue"
        field-name="billing_needs_taxcredit"
        class="align-middle" @changed="sliderSwitched"/> Necesito crédito fiscal</label>
    </div>
    <template v-if="needsTaxcredit">
      <div class="mb-4">
        <p class="mb-1"><label for="billing_person_type" class="form-label">Tipo de persona *</label></p>
        <select name="billing_person_type" id="billing_person_type" class="form-input" v-model="personType">
          <option value="NATURAL">Persona</option>
          <option value="LEGAL">Empresa</option>
        </select>
      </div>

      <p class="mb-2">
        <button class="bt clear text-sm" type="button" v-if="personType == 'NATURAL'" @click="copyBillingData">Usar misma información de pago</button>
      </p>

      <div class="overflow-hidden">
        <div class="flex flex-col md:flex-row -mx-2">
          <div class="w-full md:w-1/3 px-2 mb-2" v-if="personType == 'LEGAL'">
            <p class="mb-1"><label for="billing_taxcredit_nit" class="form-label">NIT *</label></p>
            <the-mask mask="####-######-###-#" type="text" class="form-input" name="billing_taxcredit_nit" id="billing_taxcredit_nit" placeholder="####-######-###-#" required maxlength="17" v-model="nit" />
          </div>
          <div class="w-full md:w-1/3 px-2 mb-2">
            <p class="mb-1"><label for="billing_taxcredit_line" class="form-label">Giro *</label></p>
            <input type="text" class="form-input" name="billing_taxcredit_line" id="billing_taxcredit_line" required maxlength="191" v-model="line">
          </div>
          <div class="w-full md:w-1/3 px-2 mb-2">
            <p class="mb-1"><label for="billing_taxcredit_number" class="form-label">No. de registro *</label></p>
            <input type="text" class="form-input" name="billing_taxcredit_number" id="billing_taxcredit_number" required maxlength="191" v-model="number">
          </div>
        </div>
      </div>
      <div class="overflow-hidden">
        <div class="flex flex-col md:flex-row flex-wrap -mx-2">
          <div class="flex-1 px-2 mb-2">
            <p class="mb-1"><label for="billing_taxcredit_name" class="form-label">Nombre <span v-if="personType == 'LEGAL'">(según NIT de empresa)</span> *</label></p>
            <input type="text" class="form-input" name="billing_taxcredit_name" id="billing_taxcredit_name" required maxlength="191" v-model="name">
          </div>
          <div class="flex-1 px-2 mb-2">
            <p class="mb-1"><label for="billing_taxcredit_dui" class="form-label">DUI *</label></p>
            <the-mask mask="########-#" type="text" class="form-input" name="billing_taxcredit_dui" id="billing_taxcredit_dui" required maxlength="191" placeholder="#########-#" v-if="personType == 'NATURAL'" v-model="dui" />
          </div>
          <div class="flex-1 px-2 mb-2">
            <p class="mb-1"><label for="billing_taxcredit_address" class="form-label">Dirección <span v-if="personType == 'LEGAL'">(según NIT de empresa)</span> *</label></p>
            <input type="text" class="form-input" name="billing_taxcredit_address" id="billing_taxcredit_address" required maxlength="191" v-model="address">
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'taxcredit-fields',
  props: {
    needsTaxcreditValue: { type: Boolean, default: false },
    nitValue: { type: String, default: '' },
    lineValue: { type: String, default: '' },
    numberValue: { type: String, default: '' },
    nameValue: { type: String, default: '' },
    addressValue: { type: String, default: '' },
    personTypeValue: { type: String, default: 'NATURAL' },
  },
  data() {
    return {
      needsTaxcredit: false,
      nit: '',
      line: '',
      number: '',
      name: '',
      dui: '',
      address: '',
      personType: 'NATURAL',
    }
  },
  methods: {
    sliderSwitched(newVal) {
      this.needsTaxcredit = newVal;
    },
    
    copyBillingData() {
      this.name = document.getElementById('cc_name').value;
      this.dui = document.getElementById('billing_dui').value;
      this.address = document.getElementById('billing_address').value;
    }
  },
  mounted() {
    this.needsTaxcredit = this.needsTaxcreditValue;
    this.nit = this.nitValue;
    this.line = this.lineValue;
    this.number = this.numberValue;
    this.name = this.nameValue;
    this.address = this.addressValue;
    this.personType = this.personTypeValue;
  },
}
</script>